<template>
    <div>
        <div class="header">
            <v-header></v-header>
        </div>
        <router-view></router-view>
        <v-footer></v-footer>
        <!-- <v-modal :visible="visible" @onCloseModal="handleOk" ></v-modal> -->
        <service-right></service-right>
    </div>
</template>

<script>
import vHeader from './header'
import vFooter from './footer'
// import vModal from '@/components/modal'
import serviceRight from '@/components/service-right'


export default {
    components: {
        vHeader,
        vFooter,
        serviceRight
        // vModal
    },
    data () {
        return {
            // visible:false
        }
    },
    methods:{
//   handleOk(value) {
//            this.visible = value;
//       },
    //   handleCancel() {
    //     this.visible = false;
    //   },
    }
}
</script>

<style lang="scss" scoped>
.header {
    background: #fff;
}
</style>